/**
 * Prompts the user to choose between resuming from where they left off
 * or starting from the beginning.
 *
 * @param {number} resumeIndex - The index of the first unanswered question
 * @returns {number} - The index to start from (either resumeIndex or 0)
 */
export const getStartingIndex = (resumeIndex) => {
  // No need to prompt if starting fresh (no progress or at beginning)
  if (!resumeIndex || resumeIndex === 0) {
    return 0;
  }

  // Ask user if they want to resume from where they left off
  const userWantsResume = window.confirm(
    `이전에 ${resumeIndex}개의 문제를 풀었습니다.\n${resumeIndex + 1}번 문제부터 이어서 풀겠습니까?\n\n(취소를 누르면 처음부터 다시 시작합니다)`
  );

  return userWantsResume ? resumeIndex : 0;
};
